<template>
    <mySubPage>
        <div slot="header">
            <myNav>{{$t('upd_sub_shop_setup')}}</myNav>
            <div class="sn-info-box">
                <el-row>
                    <el-col :span="12">
                        客户{{$t('x_mh')}}<span class="f-blue">{{org_cname}}</span>
                    </el-col>
                </el-row>
            </div>
        </div>
        <el-form class="pd-10" ref="form" :model="formData" :rules="rule" label-width="120px">
            <el-row>
                <el-col :span="16">
                    <el-form-item label="每日低于" prop="day_cr_qty_min">
                        <el-input v-model="formData.day_cr_qty_min">
                            <span slot="append">自动恢复<span class="f-blue">(填空不恢复)</span></span>
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item :label="$t('status')" prop="unit_status">
                <el-radio-group v-model="formData.org_status">
                    <el-radio v-for="item in org_status" :key="item.key" :label="item.key">{{item.value}}</el-radio>
                </el-radio-group>
            </el-form-item>
            <div class="tright">
                <div class="f-red mg-bottom5">警告：资料修改将立即生效，请慎重</div>
                <el-button type="primary" @click="submit">保存配置</el-button>
            </div>
        </el-form>
    </mySubPage>
</template>

<script>
    export default {
        components: {
        },
        data:function(){
            return{
                relist:false,
                org_cname:'',
                formData: {
                    org_id:'',
                    day_cr_qty_min:'',
                    org_status:''
                },
                org_status:[]
            }
        },
        mounted: function(){
            this.$parent.$parent.show_subview = true;

            var para = this.$base.getRequest();
            this.org_cname = para.org_cname;
            this.formData.org_id = para.org_id;
            this.getInfo();
        },
        methods:{
            cancel: function(){
                this.$base.linkBack();
            },
            getInfo: function(){
                this.reader_soft_upd = false;
                var data = {
                    org_id:this.formData.org_id
                }
                this.$base.showLoading();
                this.$request.sendPost("org-shop-setup/before-upd",data,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.formData = this.$base.leftJson(this.formData,data.info);
                        this.org_status = data.org_status;
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            submit: function(){
                this.$base.showLoading();
                this.$request.sendPost("org-shop-setup/upd",this.formData,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.$base.msgSuccess(error.errmsg);
                        this.relist = true;
                        this.$base.linkBack();
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            }
        },
        beforeDestroy: function () {
            this.$parent.$parent.show_subview = false;
            this.$parent.$parent.relist = this.relist;
        }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/org/shop/setup.vue